// extracted by mini-css-extract-plugin
export default {"root":"zXOaQ_zXOaQ","delete":"QCNR6_QCNR6"};